<section id="text-skeleton-screen" class="relative w-full">
    <div class="flex flex-col animate-pulse h-screen justify-between overflow-hidden">
        <div class="relative w-full h-4 bg-gray-300" *ngFor="let item of [1,2,3,4,5,6,7,8,9,1,2,3,4,5,6,7,8,9]"></div>
    </div>
</section>